<script>
    import Fa from 'svelte-fa'
    import Content from '../../_common/content.svelte'
    import Zexpand from '../../_common/z/zexpand.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'
</script>

<Content>
    <Zframe title="Log de versões - Zandu" class="m-3 mb-6">
        <div class="v_items">
            <div class="v_item">
                Versão 2024.029
                <ul>
                    <li>Recurso: opção 'sair de todos os dispositivos conectados'.</li>
                </ul>
            </div>
            <div class="v_item">
                Versão 2024.028
                <ul>
                    <li>Melhoria: documentos de atendimento com campos somente leitura.</li>
                    <li>Bug: bug intermitente com mensagem genérica de erro ao salvar um agendamento.</li>
                    <li>Bug: valor total vendido "hoje" na dashboard com fuso horário global (e não local).</li>
                </ul>
            </div>
            <div class="v_item">
                Versão 2024.027
                <ul>
                    <li>Recurso: versão 2 da confirmação de agenda aumentando grau de personalização.</li>
                    <li>Melhoria: filtragem de dados nas tabelas/listagens.</li>
                    <li>Melhoria: mais personalizações do app de agendamentos e agendas.</li>
                    <li>Melhoria: gestão de usuários por outros usuários além do proprietário.</li>
                    <li>Bug: melhor tratamento do fuso horário pelo app de agendamentos.</li>
                    <li>Bug: correção de vários pequenos bugs.</li>
                </ul>
            </div>
            <div class="v_item">
                Versão 2024.026
                <ul>
                    <li>Melhoria: tempo de expiração para pacotes adquiridos.</li>
                </ul>
            </div>
            <div class="v_item">
                Versão 2024.025
                <ul>
                    <li>Recurso: metas individuais no painel de Metas.</li>
                </ul>
            </div>
            <div class="v_item">
                Versão 2024.024
                <ul>
                    <li>
                        Recurso: limpeza da caixa de saída.
                        <Zexpand class="opacity-80">
                            Agora você pode limpar mensagens que estejam em sua caixa de saída sem precisar acionar o
                            suporte.
                        </Zexpand>
                    </li>
                    <li>
                        Melhoria: solicitação do nome do cliente para novos cadastros através do app de agendamentos.
                    </li>
                    <li>Melhoria: prazo da entrada de um pagamento no PDV para cheques ou boletos.</li>
                </ul>
            </div>
            <div class="v_item">
                Versão 2024.023
                <ul>
                    <li>
                        Recurso: etiquetas inteligentes.
                        <Zexpand class="opacity-80">
                            Você pode etiquetar manualmente ou automaticamente pesosas, e assim gerar relatórios
                            inteligentes para tomada de decisão.
                        </Zexpand>
                    </li>
                    <li>Recurso: gráfico de geração de caixa no financeiro.</li>
                    <li>Bug: correção de alguns totais da dashboard que não respeitavam o fuso horário selecionado.</li>
                </ul>
            </div>
            <div class="v_item">
                Versão 2024.022
                <ul>
                    <li>
                        Recurso: versão 4 do financeiro.
                        <Zexpand class="opacity-80">
                            Remodelação total do financeiro. Contas a pagar e a receber com aba própria, dando mais
                            controle aos compromissos. Integração de contas a receber com o PDV. Integração com o Open
                            Finance.
                        </Zexpand>
                    </li>
                </ul>
            </div>
            <div class="v_item">
                Versão 2024.021
                <ul>
                    <li>
                        Recurso: permissões para autorizar ou proibir um usuário de ter acesso à agenda de outro
                        usuário.
                    </li>
                </ul>
            </div>
            <div class="v_item">
                Versão 2024.020
                <ul>
                    <li>Recurso: emissão de boletos avulsos para clientes com cobrança ativa no ZanduPay.</li>
                    <li>Recurso: cobrança recorrente através de boleto no ZanduPay.</li>
                </ul>
            </div>
            <div class="v_item">
                Versão 2024.019
                <ul>
                    <li>
                        Melhoria: no controle de saldo do cliente, adição da coluna <code>ajustes</code> para facilitar acompanhamento
                        de ajustes manuais.
                    </li>
                    <li>
                        Bug: corrigido bug que impedia o recálculo de comissões ao editar uma venda iniciada na Agenda.
                    </li>
                    <li>
                        Bug: corrigido bug que exibia lançamentos no PDV feitos após as 21hrs no caixa do dia seguinte.
                    </li>
                </ul>
            </div>
            <div class="v_item">
                Versão 2024.018
                <ul>
                    <li>Bug: corrigido bug ao importar um arquivo CSV com data inválida.</li>
                    <li>Melhoria: melhoria de usabilidade na tela de importação de arquivo CSV.</li>
                </ul>
            </div>
            <div class="v_item">
                Versão 2024.017
                <ul>
                    <li>
                        Recurso: criada lista de agendamentos futuros no aplicativo do cliente.
                        <Zexpand class="opacity-80">
                            Agora no aplicativo de agendamentos o cliente poderá também consultar a sua relação de
                            agendamentos futuros.
                        </Zexpand>
                    </li>
                    <li>
                        Bug: corrigido bug do assistente de onboarding que impedia a adição de usuário já existente.
                    </li>
                    <li>
                        Bug: corrigido erro que impedia a confirmação de agenda funcionar para agendamentos online em
                        alguns casos específicos.
                    </li>
                </ul>
            </div>
            <div class="v_item">
                Versão 2024.016
                <ul>
                    <li>
                        Bug: corrigido bug no lançamento do PDV que duplicava o lançamento de pacote em uma condição
                        específica.
                    </li>
                    <li>Melhoria: aumento de compatibilidade para mais modelos de tablet (beta).</li>
                </ul>
            </div>
            <div class="v_item">
                Versão 2024.015
                <ul>
                    <li>Melhoria: aumento de compatibilidade com ipads (beta).</li>
                </ul>
            </div>

            <div class="v_item">
                Versão 2024.014
                <ul>
                    <li>
                        Recurso: adição do recurso de baixa de comanda na <code>agenda</code> com a opção "sem comissão"
                        ao atendente.
                        <Zexpand class="opacity-80"
                            >Em alguns casos pode ser necessário dar baixa em um atendimento e não pagar a comissão ao
                            atendente. Agora isso pode ser feito direto da baixa do agendamento <Fa
                                icon={faShoppingCart}
                            ></Fa>.</Zexpand
                        >
                    </li>
                    <li>Recurso: ocultar agendamentos antigos no perfil da <code>Pessoa</code>, na aba Agenda.</li>
                    <li>Bug: correção das cores do recurso <code>Metas</code> no modo claro.</li>
                </ul>
            </div>
            <div class="v_item">
                Versão 2024.013
                <ul>
                    <li>Recurso: criação do histórico de alterações (este log).</li>
                </ul>
            </div>
        </div>
    </Zframe>
</Content>

<style>
    .v_items > div {
        padding-bottom: 16px;
    }
    .v_items > div:last-child {
        padding-bottom: 0px;
    }
</style>
